import { useAdminAgentDrawer } from '../context/AdminAgentDrawerContext';
import { AdminAgentPanel } from './AdminAgentPanel';
import { DrawerResizeHandle } from './DrawerResizeHandle';

/**
 * Right-hand, full-height chat drawer for the admin assistant. Stays mounted after the first
 * open so closing it does not drop the conversation or its socket.
 */
export const AdminAgentDrawer: React.FC = () => {
  const drawer = useAdminAgentDrawer();
  const { open, session, sessionState } = drawer;

  if (sessionState === 'idle' || sessionState === 'unavailable') return null;

  return (
    <aside
      aria-label="Admin assistant"
      aria-hidden={!open}
      style={{ width: drawer.width }}
      className={`fixed right-0 top-0 z-[1300] h-screen max-w-full flex-col border-l border-slate-200 bg-white shadow-xl dark:border-slate-700 dark:bg-slate-800 ${
        open ? 'flex' : 'hidden'
      }`}
    >
      <DrawerResizeHandle
        width={drawer.width}
        onWidthChange={drawer.setWidth}
        onResizingChange={drawer.setResizing}
        onReset={drawer.resetWidth}
      />
      {session && sessionState !== 'loading' ? (
        <AdminAgentPanel
          key={session.conversationPublicId}
          session={session}
          onNewConversation={drawer.newConversation}
          onOpenConversation={drawer.openConversation}
          onClose={drawer.close}
        />
      ) : (
        <div className="flex flex-1 items-center justify-center p-6 text-sm text-slate-500 dark:text-slate-400">
          Starting the assistant…
        </div>
      )}
    </aside>
  );
};
